import { useState, ChangeEvent } from "react";
import {
  IconButton,
  Grid,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Typography,
  Button,
  Slider,
  Input,
  Divider,
  InputAdornment,
} from "@material-ui/core";

import { BigNumber } from "bignumber.js";

import { RootState, RootDispatch } from "../../model";
import { useRematch } from "../../utils/useRematch";
import ETH from "../../assets/eth.svg";
import MiniLogoIcon from "../../assets/mini-logo-icon.png";

import CloseIcon from "@material-ui/icons/Close";

import "./index.less";

const marks = [
  {
    value: 1,
    label: 1,
  },
  {
    value: 3,
    label: 3,
  },
  {
    value: 5,
    label: 5,
  },
  {
    value: 10,
    label: 10,
  },
  {
    value: 15,
    label: 15,
  },
  {
    value: 20,
    label: 20,
  },
];

const mapState = (state: RootState) => ({
  modalState: { ...state.modal },
  ...state.main,
  loading: state.loading,
});

const mapDispatch = (dispatch: RootDispatch) => ({
  ...dispatch.modal,
  ...dispatch.main,
});

// const UNIT_PRICE = 0.08;

export default function MintModal() {
  const [
    { modalState, userInfo, loading, saleMintedNum, UNIT_PRICE },
    { closeModal, mint },
  ] = useRematch(mapState, mapDispatch);

  const [numbers, setNumbers] = useState<number>(5);

  const handleSliderChange = (event: any, newValue: number | number[]) => {
    if (typeof newValue === "number") {
      setNumbers(newValue);
    }
  };

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    setNumbers(event.target.value === "" ? 0 : Number(event.target.value));
  };

  function valuetext(value: number) {
    return `${value} Hero`;
  }

  const handleBlur = () => {
    if (numbers < 0) {
      setNumbers(0);
    } else if (numbers > 20) {
      setNumbers(100);
    }
  };

  return (
    <Dialog
      fullWidth
      maxWidth="sm"
      open={modalState.mint}
      className="mint-modal"
      keepMounted
      onClose={closeModal}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
    >
      <DialogTitle>
        <div className="dialog-title">
          <Typography variant="h6">MINT</Typography>
          <IconButton aria-label="close" onClick={closeModal}>
            <CloseIcon />
          </IconButton>
        </div>
      </DialogTitle>
      <DialogContent style={{ padding: "16px 24px" }}>
        <DialogContentText id="alert-dialog-slide-description" component="div">
          <Typography id="discrete-slider-custom" gutterBottom>
            {/* {saleMintedNum} */}
          </Typography>
          <Typography id="discrete-slider-custom" gutterBottom>
            How many KungFu Heroes do you want to buy?
          </Typography>
          <Grid
            container
            spacing={4}
            alignItems="center"
            justify="space-between"
          >
            <Grid item xs={7} lg={9}>
              <Slider
                getAriaValueText={valuetext}
                onChange={handleSliderChange}
                value={typeof numbers === "number" ? numbers : 0}
                aria-labelledby="discrete-slider-custom"
                step={1}
                min={1}
                max={20}
                valueLabelDisplay="auto"
                marks={marks}
              />
            </Grid>
            <Grid item xs={5} lg={3}>
              <Input
                value={numbers}
                // margin="dense"
                fullWidth
                style={{ textAlign: "right" }}
                onChange={handleInputChange}
                startAdornment={
                  <InputAdornment position="start">
                    <img src={MiniLogoIcon} width="24px" alt="" />
                  </InputAdornment>
                }
                endAdornment={
                  <InputAdornment position="end">Hero</InputAdornment>
                }
                onBlur={handleBlur}
                inputProps={{
                  step: 1,
                  min: 1,
                  max: 20,
                  type: "number",
                  "aria-labelledby": "input-slider",
                }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
        <DialogContentText component="div">
          <div className="price">
            <div className="price-text">Price</div>
            <div className="total-calc">
              <span style={{ fontWeight: 600, marginLeft: "5px" }}>
                {UNIT_PRICE}
              </span>
              <img src={ETH} className="eth-logo" width="20px" alt="" /> /
              KungFu Hero
            </div>
          </div>
        </DialogContentText>
        <Divider variant="middle" />
        <DialogContentText component="div">
          <div className="total">
            <div className="total-text">Total</div>
            <div className="total-price">
              {new BigNumber(numbers).times(UNIT_PRICE).toString()}
              <img src={ETH} className="eth-logo" width="20px" alt="" />
            </div>
          </div>
        </DialogContentText>
        <DialogActions
          style={{
            padding: "8px 0px",
            marginTop: "16px",
            position: "relative",
          }}
        >
          <Button
            fullWidth
            onClick={() => {
              mint(numbers);
            }}
            disabled={!userInfo.address || loading.effects.main.mint}
            variant="contained"
            color="secondary"
          >
            {userInfo.address ? "MINT NOW" : "Please Connect Wallet"}
          </Button>
          {/* {loading.effects.main.mint && (
            <CircularProgress size={24} className="mint-button-loading" />
          )} */}
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
}
